export enum QRModes {
  createPatient = 1,
  createDoctor,
  scanPatient,
}
